import { MAIN_SELECTION_ENTITIES } from "../constants/mainSelectionEntities";
import {
  bestPhoneFromPhoneGroup,
  multiPhoneGroupsForOfferType,
  onePhoneSelected,
  selectedMainEntity
} from "./mainEntitySelection";
import { pickPortalDataEntity } from "./portalData";
import { SORTS } from "../constants/sorts";
import { WIDGETS } from "../constants/widgets";

function needToChangeFilterPhoneToBestPhoneFromGroup(
  portalData,
  clientConfig,
  offerType,
  filter
) {
  try {
    const preSelect =
      clientConfig.widgetOptions[offerType].preSelectPhoneFromPhoneGroup;
    const selectedEntity = selectedMainEntity(offerType, filter);

    if (preSelect) {
      if (
        selectedEntity === MAIN_SELECTION_ENTITIES.multiPhone ||
        selectedEntity === MAIN_SELECTION_ENTITIES.unknown
      ) {
        if (filter.phoneId.length === 0 && filter.phoneVariantId.length === 0) {
          return false;
        } else if (multiPhoneGroupsForOfferType(portalData, offerType)) {
          return false;
        } else if (onePhoneSelected(portalData, filter) === undefined) {
          return undefined;
        } else {
          return !onePhoneSelected(portalData, filter);
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (e) {
    return undefined;
  }
}

function needToAddFilterPhoneFromPhoneVariants(
  portalData,
  clientConfig,
  offerType,
  filter
) {
  try {
    if (filter.phoneVariantId.length > 0) {
      const onePhoneInSelection = onePhoneSelected(portalData, filter);
      if (filter.phoneId.length === 0) {
        return onePhoneInSelection;
      } else if (onePhoneInSelection === undefined) {
        return undefined;
      } else {
        return !onePhoneInSelection;
      }
    } else {
      return false;
    }
  } catch (e) {
    return undefined;
  }
}

const filterMightNeedChange = (portalData, clientConfig, offerType, filter) => {
  if (WIDGETS[clientConfig.widget].portalData[offerType]) {
    const changeToBest = needToChangeFilterPhoneToBestPhoneFromGroup(
      portalData,
      clientConfig,
      offerType,
      filter
    );
    const changePhone = needToAddFilterPhoneFromPhoneVariants(
      portalData,
      clientConfig,
      offerType,
      filter
    );

    return !(changeToBest === false && changePhone === false);
  } else {
    return false;
  }
};

const changeFilter = (
  portalData,
  clientConfig,
  offerType,
  filter,
  updateFilter,
  updateSort
) => {
  try {
    if (
      needToChangeFilterPhoneToBestPhoneFromGroup(
        portalData,
        clientConfig,
        offerType,
        filter
      )
    ) {
      const bestPhone = bestPhoneFromPhoneGroup(portalData, offerType, filter);

      if (bestPhone) {
        updateSort(SORTS.bestTco);
        updateFilter({
          phoneId: [bestPhone.id],
          phoneVariantId: bestPhone.phoneVariants.map(pV => pV.id)
        });
      }
    } else if (
      needToAddFilterPhoneFromPhoneVariants(
        portalData,
        clientConfig,
        offerType,
        filter
      )
    ) {
      const phoneVariant = pickPortalDataEntity(
        portalData,
        "phoneVariant",
        filter.phoneVariantId
      );

      updateSort(SORTS.bestTco);
      if (phoneVariant != null) {
        updateFilter({ phoneId: [phoneVariant.phone.id] });
      }
    }
  } catch (e) {
    // do nothing
  }
};

export { filterMightNeedChange, changeFilter };
